import { simpleFetch } from './customFetch';

export const getStatesList = (countryId) => (
  simpleFetch(`/states/by-country-id/${countryId}`, {}, process.env.REACT_APP_LOCALIZATION_API)
);

export const verifyAddress = (address) => (
  simpleFetch(
    '/location/verify-address',
    {
      method: 'POST',
      body: JSON.stringify({
        city: address.city,
        countryCode: address.countryCode,
        primaryLine: address.primaryLine,
        secondaryLine: address.secondaryLine,
        state: address.state,
        zip: address.zip,
      }),
    },
    process.env.REACT_APP_GROWTH_API,
  )
);
